export default "__VITE_ASSET__3d5a271f__"